module.exports = __webpack_public_path__ + "img/图片6.ef41aa56.png";